import { Component,  Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'mobile-link-card',
    template: `
<icon class="type" *ngIf="!!icon" [icon]="icon"></icon>
<div class="border-wrapper" [ngClass]="{ top: borderTop, bottom: borderBottom, withIcon: !!icon }">
  <div *ngIf="title" class="card-title">{{ title }}</div>
  <div style="flex:1;"></div>
  <ng-content></ng-content>
  <icon class="right-arrow" [icon]="'expand18'"></icon>
</div>

`,
    styles: [`
  :host { display: flex; align-items: center; width: 100%; }
  .border-wrapper { display: flex; align-items: center; padding: 10px; width: 100%; }
  .border-wrapper.withIcon { padding-left: 0px; }
  .border-wrapper.bottom { border-bottom: 1px solid #ddd; }
  .border-wrapper.top { border-top: 1px solid #ddd; }
  icon.right-arrow { color: rgba(0,0,0,0.4); transform: rotate(270deg); }
  icon.type { width: 24px; min-width: 12px; margin: 10px; }
`],
    standalone: true,
    imports: [IconComponent, CommonModule]
})

export class MobileLinkCardComponent {
  @Input() borderTop = false
  @Input() borderBottom = false
  @Input() icon: string
  @Input() title: string
}
